export function getTimeOfDayGreeting(date: Date = new Date()): 'Bom dia' | 'Boa tarde' | 'Boa noite' {
  const hour = date.getHours();
  if (hour >= 5 && hour < 12) return 'Bom dia';
  if (hour >= 12 && hour < 18) return 'Boa tarde';
  return 'Boa noite';
}

export function buildWelcomeMessage(date: Date = new Date()): string {
  const greeting = getTimeOfDayGreeting(date);
  return `${greeting}! Sou a assistente da Minas Brasil. Me envie sua receita (texto, foto ou áudio) que eu faço seu orçamento.`;
}

export function formatTime(epochMs: number): string {
  return new Date(epochMs).toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export function formatPrice(brl: number): string {
  return `R$ ${brl.toFixed(2).replace('.', ',')}`;
}
